// Meta Pixel-integration med samtyckesstyrd laddning.
//
// - Skriptet laddas ENBART efter att användaren gett cookie-samtycke.
// - Alla events som `trackLead`, `trackCompleteRegistration`, `trackPurchase`
//   kan anropas när som helst; om pixeln inte är laddad ännu köas eventet
//   och skickas när `initMetaPixel` kallas.
// - Pixel-ID läses från `REACT_APP_META_PIXEL_ID`. Är variabeln tom eller
//   saknas är hela modulen no-op (säker att kalla i utveckling/preview).

const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || "").trim();

let pixelLoaded = false;
const queue = [];

function loadPixelScript(pixelId) {
  if (typeof window === "undefined" || window.fbq) return;
  // Officiell Meta-snippet, portad till modul-form.
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
}

export function isMetaPixelConfigured() {
  return Boolean(PIXEL_ID);
}

export function initMetaPixel() {
  if (!PIXEL_ID) return; // ingen konfiguration → no-op
  if (pixelLoaded) return;
  loadPixelScript(PIXEL_ID);
  pixelLoaded = true;
  window.fbq("track", "PageView");
  // Flusha köade events
  while (queue.length) {
    const [event, params] = queue.shift();
    try {
      window.fbq("track", event, params || {});
    } catch {
      // silent
    }
  }
}

function track(event, params) {
  if (!PIXEL_ID) return;
  if (!pixelLoaded || typeof window === "undefined" || !window.fbq) {
    queue.push([event, params]);
    return;
  }
  try {
    window.fbq("track", event, params || {});
  } catch {
    // silent — pixeln ska aldrig blockera UI
  }
}

export const trackPageView = () => track("PageView");
export const trackLead = (params) => track("Lead", params);
export const trackCompleteRegistration = (params) =>
  track("CompleteRegistration", params);
export const trackPurchase = (params) => track("Purchase", params);
